import { useEffect, useState } from "react";
import "./App.css";

function App() {
  const [quizzes, setQuizzes] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [quiz, setQuiz] = useState(null);
  const [selected, setSelected] = useState(null);
  const [result, setResult] = useState(null);
  const [layout, setLayout] = useState("center-center");
  const [darkMode, setDarkMode] = useState(false);
  const [shuffle, setShuffle] = useState(true);
  const [shuffleq, setShuffleq] = useState(true);
  const [isAnswering, setIsAnswering] = useState(false);
  const [loading, setLoading] = useState(true);

  const resetState = () => {
    setSelected(null);
    setResult(null);
    setIsAnswering(false);
  };

  // --------------------------------------------------
  // LOAD QUIZ LIST
  // --------------------------------------------------
  useEffect(() => {
    fetch("/api/quizzes", {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setQuizzes(data));
  }, []);

  // -----------------------------
  // LOAD QUIZ (SESSION-BASED)
  // -----------------------------
  const loadQuiz = async (name = null) => {
    setLoading(true);

    console.log("name =", name);
    console.log("shuffle =", shuffle);
    console.log("shuffleq =", shuffleq);

    console.log(JSON.stringify({
      quiz_name: name,
      shuffle,
      shuffleq
    }));

    const res = await fetch("/api/quiz", {
      method: "POST",
      credentials: "include", // 🔥 WICHTIG: Session Cookie aktivieren
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        quiz_name: name,
        shuffle: shuffle,
        shuffleq: shuffleq,
      })
    });

    const data = await res.json();
    setQuiz(data);

    setSelected(null);
    setResult(null);
    setSelectedQuiz(name);

    setLoading(false);
  };

  // -----------------------------
  // INITIAL LOAD (RESUME)
  // Quiz Load, Laden der Quizdaten aus dem Backend in den Frontend-State
  // -----------------------------
  // useEffect(() => {
  //   loadQuiz();
  // }, []);

  // ✅ Keyboard Handling (FIXED)
  useEffect(() => {
    const handleKeyDown = (e) => {

      const key = e.key.toUpperCase();
      const q = quiz;
      if (!q) return;

      // prevent scroll on space
      if (e.code === "Space") e.preventDefault();

      // 🚫 während Antwort läuft: ALLES blockieren
      if (isAnswering) return;

      // 🎯 Answer
      if (["A", "B", "C", "D"].includes(key)) {
        answer(key);
        return;
      }

      // 👉 Next (nur wenn Antwort sichtbar ist)
      if ((e.code === "Space" || key === "ENTER") && selected) {
        next();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [quiz, selected, isAnswering]);

  // -----------------------------
  // ANSWER QUESTION
  // -----------------------------
  const answer = async (key) => {
    if (selected || isAnswering || !quiz || quiz.finished) return;

    setIsAnswering(true);
    setSelected(key);

    const res = await fetch("/api/answer", {
      method: "POST",
      credentials: "include", // 🔥 Session bleibt erhalten
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        quiz_name: quiz.quiz_name,
        question_id: quiz.question_id,
        answer: key
      })
    });

    const data = await res.json();

    if (data.correct) {
      setResult("correct");
    } else {
      //setResult(data.correct_answer);
      setResult(data);
    }

    setIsAnswering(false);
  };

  // -----------------------------
  // NEXT QUESTION
  // -----------------------------
  const next = () => {
    if (isAnswering) return;

    setSelected(null);
    setResult(null);
    console.log(quiz.quiz_name)
    loadQuiz(quiz.quiz_name);
  };

  // -----------------------------
  // STOP QUIZ
  // -----------------------------
  const stop = async () => {
    console.log(`Stop ${quiz.quiz_name}`)
    await fetch("/api/stop", {
      method: "POST",
      credentials: "include", // 🔥 Session bleibt erhalten
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        quiz_name: quiz.quiz_name
      })
    });

    loadQuiz();
  };

  // -----------------------------
  // RESTART QUIZ
  // -----------------------------
  const restart = async () => {
    console.log(`Restart ${quiz.quiz_name}`)
    await fetch("/api/restart", {
      method: "POST",
      credentials: "include", // 🔥 Session bleibt erhalten
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        quiz_name: quiz.quiz_name
      })
    });

    resetState();
    loadQuiz(quiz.quiz_name);
  };

  const downloadResult = async () => {
    const res = await fetch("/api/export");
    const data = await res.json();

    const blob = new Blob([data.result], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "quiz_result.txt";
    a.click();

    window.URL.revokeObjectURL(url);
  };


  const layoutClass =
    layout === "top-center"
      ? "page page-top-center"
      : "page page-center-center";

  const themeClass = darkMode ? "dark" : "light";

  const styles = {
    panel: {
      position: "fixed",
      top: 10,
      right: 10,
      width: 160,
      padding: 10,
      borderRadius: 10,
      background: "white",
      boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      zIndex: 9999
    },

    panelTitle: {
      fontSize: 12,
      fontWeight: "bold",
      marginBottom: 4
    },

    control: {
      width: "100%"
    },

    toggle: {
      fontSize: 12,
      display: "flex",
      alignItems: "center",
      gap: 6
    }
  };


  // --------------------------------------------------
  // QUIZ SELECT SCREEN
  // --------------------------------------------------
  if (!selectedQuiz) {
    return (
      <div className="page page-center-center">
        <div className="card">

          <h1>📚 Quiz auswählen</h1>

          {quizzes.length === 0 && <p>Lade Quizzes...</p>}

          {quizzes.map(q => (
            <button
              key={q.name}
              className="button-primary"
              onClick={() => loadQuiz(q.name)}
              style={{ margin: 5 }}
            >
              ▶ {q.name}
            </button>
          ))}

        </div>
      </div>
    );
  }

  // -----------------------------
  // LOADING STATE
  // -----------------------------
  if (loading || !quiz) {
    return (
      <div className="page">
        <div className="card">
          <h2>⏳ Lade Quiz...</h2>
        </div>
      </div>
    );
  }

  // -----------------------------
  // FINISHED STATE
  // -----------------------------
  if (quiz.finished) {
    return (
      <div className={`${layoutClass} ${themeClass}`}>
        <div className="card">
          <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
            <b>[{quiz.quiz_name}]</b>
          </div>
          <h2>🏁 Fertig!</h2>
          <h3>Score: {quiz.score} / {quiz.total}</h3>

          <button className="button-primary" onClick={downloadResult}>
            ⬇ Ergebnis herunterladen
          </button>

          <button className="button-secondary" onClick={restart}>
            🔁 Neustart
          </button>
        </div>
      </div>
    );
  }

  // -----------------------------
  // PROGRESS
  // -----------------------------
  const q = quiz;
  const progress = Math.round((quiz.current / quiz.total) * 100);

  // -----------------------------
  // CURRENT QUESTION
  // -----------------------------
  return (
    <div className={`${layoutClass} ${themeClass}`}>

      {/* Control Panel */}
      <div className="panel">
      
      <div style={styles.panelTitle}>⚙ Control Panel</div>

      {/* Layout */}
      <select
        value={layout}
        onChange={(e) => setLayout(e.target.value)}
        style={styles.control}
      >
          <option value="center-center">Center</option>
          <option value="top-center">Top</option>
        </select>

      {/* Dark Mode */}
      <label style={styles.toggle}>
          <input
            type="checkbox"
            checked={darkMode}
            onChange={() => setDarkMode(d => !d)}
          />
        🌙 Dark Mode
        </label>

      {/* Shuffle Answers */}
      <label style={styles.toggle}>
          <input
            type="checkbox"
            checked={shuffle}
            onChange={() => setShuffle(s => !s)}
          />
          🔀 Shuffle Answers
      </label>

      {/* Shuffle Questions */}
      <label style={styles.toggle}>
          <input
            type="checkbox"
            checked={shuffleq}
            onChange={() => setShuffleq(s => !s)}
          />
          🔀 Shuffle Questions
      </label>

      <button
        onClick={stop}
        style={{
          fontSize: 12,
          padding: "6px 8px",
          cursor: "pointer"
        }}
      >
        🔁 Stop
      </button>

      <button
        onClick={restart}
        style={{
          fontSize: 12,
          padding: "6px 8px",
          cursor: "pointer"
        }}
      >
        🔁 Restart
      </button>

      </div>

      {/* Card */}
      <div className="card">

        {/* Header */}
        <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
          <b>[{quiz.quiz_name}]</b>
        </div>
        <div className="header">
          <div>Score: {quiz.score}</div>
          <div>{quiz.current} / {quiz.total}</div>
        </div>

        {/* 📊 Progress Bar */}
        <div style={{ height: 6, background: "#eee", borderRadius: 5 }}>
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              background: "#4caf50",
              borderRadius: 5,
              transition: "width 0.3s"
            }}
          />
        </div>

        {/* Question */}
        <h2>{quiz.question}</h2>

        {/* Options */}
        <div className="options">
          {Object.entries(quiz.options).map(([key, val]) => {

            const isSelected = selected === key;

            const isCorrect =
              result && result.correct && isSelected;

            const isWrong =
              result && !result.correct && isSelected;

            const correctAnswer =
              result && !result.correct && result.correct_answer === key;

            return (
              <button
                key={key}
                className="option"
                onClick={() => answer(key)}
                disabled={!!selected}
                style={{
                  background: isCorrect
                    ? "#d1f7d6"
                    : isWrong
                    ? "#ffd6d6"
                    : correctAnswer
                    ? "#d1f7d6"
                    : "#f7f7f7",

                  border:
                    isCorrect || correctAnswer
                      ? "2px solid #4caf50"
                      : "1px solid #ddd",

                  cursor: selected ? "default" : "pointer"
                }}
              >
                <strong>{key})</strong> {val}
              </button>
            );
          })}
        </div>

        {/* Feedback */}
        {selected && (
          <div className="feedback">
            {result === "correct"
              ? "✅ Richtig!"
              : `❌ Falsch! (✅ ${result ? result.correct_answer : ""})`}

            <button className="button-primary" onClick={next}>
              Weiter → (Space / Enter)
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default App;
